import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import { Controller, useFormContext } from "react-hook-form";
import { useGetCodeLevel } from "../hooks/useGetCodeLevel";

const ProducerCodeProducerSection = () => {
  const formMethods = useFormContext();
  const {
    control,
    formState: { errors },
    register,
    watch,
    setValue,
  } = useFormContext();

  const { data: codeLevels, isFetching: codeLevelsLoading } = useGetCodeLevel();
  const codeLevelOptions = codeLevels
    ?.filter(
      (cLevels) => cLevels.isActive === true && cLevels.codeLevelName !== ""
    )
    ?.map((x) => {
      return { label: x.codeLevelName, value: x.codeLevelName };
    });

  return (
    <>
      <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-3 items-center w-full gap-y-2 gap-x-5">
        <TextInputLabelHookForm
          name="producerCode"
          // label="Producer Code"
          label={
            formMethods.watch("carrierId") === 20
              ? "Princeton Code" // if National General Carrier Name
              : "Producer Code" // default label
          }
          type="text"
          register={formMethods.register("producerCode", {
            required: {
              value: true,
              message: "Required Field",
            },
          })}
          required={true}
          className={
            formMethods.formState.errors.producerCode &&
            "border-2 border-red-500  col-span-2"
          }
          secondDiv="grid grid-cols-3 w-full items-center gap-2"
        />
        <Controller
          control={control}
          name="codeLevel"
          rules={{ required: true }}
          render={({ field }) => (
            <SelectHookFormSingle
              label="Code Level"
              value={field.value ? field.value : null}
              options={codeLevelOptions}
              field={field}
              onChange={(e) => {
                field.onChange(e ? e.value : null);
                formMethods.setValue("codeLevel", e ? e.value : "");
              }}
              className={
                errors.codeLevel && "border-2 border-red-500 col-span-2 "
              }
              required={true}
              secondDiv="grid grid-cols-3 w-full items-center gap-2"
              isLoading={codeLevelsLoading}
            />
          )}
        />
        <TextInputLabelHookForm
          name="producerSubCode"
          label="Sub Code"
          type="text"
          register={register("producerSubCode", {})}
          secondDiv="grid grid-cols-3 w-full items-center gap-2"
        />
      </div>
    </>
  );
};

export default ProducerCodeProducerSection;
